export const SELF_SCHEDULE_ENDPOINTS = {
    GET_PROVIDER_AVAILABILITY: '/providers/providerAvailability',
    POST_SCHEDULE_APPOINTMENT: '/providers/schedule',
    GET_RECENT_APPOINTMENTS: '/appointments/recent',
} as const;
